import s from './PackageAccordion.module.scss';
import { usePowerPackageData } from 'hooks/usePowerPackageData';
import { formatPowerPackageTitle } from 'utils/powerPackageHelper';

export const PackageAccordion = ({
  onSelectPackage,
  product,
}: {
  onSelectPackage: (uid: string) => void;
  product?: string;
}) => {
  const { powerPackageData } = usePowerPackageData();

  return (
    <>
      <div className={s.packageList}>
        {powerPackageData &&
          powerPackageData?.allPower_packages.edges.map((edge, index) => {
            const uid = edge.node._meta.uid.split('_')[0];
            const item = edge.node;
            const isSelected = product === uid;
            return (
              <PackageAccordionOption
                key={`powerPackageCard-${index}`}
                onClick={() => onSelectPackage(uid)}
                isSelected={isSelected}
                package_name={item.package_name}
                short_description={item.short_description}
              />
            );
          })}
        <PackageAccordionOption
          key={`powerPackageCard-no-option`}
          onClick={() => onSelectPackage('')}
          isSelected={!product}
          package_name="Engin orkuleið valin"
          short_description="Þú þarft ekki að ákveða þig núna; þú getur valið og skipt um orkuleiðir hvenær sem er."
        />
      </div>
    </>
  );
};

interface PowerPackageCardProps {
  onClick: () => void;
  isSelected: boolean;
  package_name: string;
  short_description?: string;
}

const PackageAccordionOption = ({
  onClick,
  isSelected,
  package_name,
  short_description,
}: PowerPackageCardProps) => {
  const { preTitle, postTitle } = formatPowerPackageTitle(package_name);

  return (
    <button
      onClick={onClick}
      className={s.packageList__item}
      style={{
        backgroundColor: isSelected ? '#F3F1F4' : '#FDFDFD',
      }}
    >
      <div className={s.container}>
        <input
          type="checkbox"
          name={package_name}
          checked={isSelected}
          tabIndex={0}
          className={s.input}
          readOnly
        />
        <span className={s.checkmark}></span>
      </div>
      <div className={s.textContainer}>
        <h3 className={s.packageName}>
          <b>{preTitle}</b>
          {postTitle}
        </h3>

        <p>{short_description}</p>
      </div>
    </button>
  );
};
